import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";
import { TESTIMONIALS } from "../data/content";
import { fadeUp, viewportOnce, EYEBROW } from "../lib/motion";

export const Testimonials = () => {
  return (
    <section id="testimoni" data-testid="testimonials-section" className="relative bg-graytone-light py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce}>
          <span className={EYEBROW}>Testimoni</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-[1.05] font-bold">
            Apa Kata <span className="italic text-gold-dark">Klien Kami</span>
          </h2>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-12"
        >
          <Carousel opts={{ loop: true }} className="w-full">
            <CarouselContent>
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={i} data-testid={`testimonial-${i}`}>
                  <div className="mx-auto max-w-2xl rounded-3xl bg-white border border-graytone-medium/60 shadow-soft p-10 md:p-14">
                    <Quote className="h-12 w-12 text-gold/40 mx-auto" />
                    <p className="mt-6 font-serif text-2xl md:text-3xl leading-snug text-navy italic">
                      “{t.quote}”
                    </p>
                    <div className="mt-8 flex flex-col items-center gap-3">
                      <div className="flex gap-1">
                        {Array.from({ length: t.rating }).map((_, s) => (
                          <Star key={s} className="h-5 w-5 fill-gold text-gold" />
                        ))}
                      </div>
                      <p className="font-semibold text-navy">{t.name}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            {TESTIMONIALS.length > 1 && (
              <>
                <CarouselPrevious data-testid="testimonial-prev" className="hidden sm:flex" />
                <CarouselNext data-testid="testimonial-next" className="hidden sm:flex" />
              </>
            )}
          </Carousel>

          <p className="mt-8 text-sm text-graytone-dark">
            Lihat ulasan klien kami di Google <span className="text-gold-dark font-medium">(segera hadir)</span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};
